/**
 * WCAG 2.2.6: warn before inactivity ends the session, offer extend, save drafts on expiry.
 * Config: window.theme.sessionTimeout (set in session-timeout-warning.liquid).
 */
(function () {
  var cfg = window.theme && window.theme.sessionTimeout;
  if (!cfg || !cfg.enabled) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var routes = window.theme.routes || {};
  var strings = cfg.strings || {};

  var minutes = parseFloat(cfg.minutes);
  if (!isFinite(minutes) || minutes < 1) minutes = 25;
  var warnSec = parseFloat(cfg.warningSeconds);
  if (!isFinite(warnSec) || warnSec < 20) warnSec = 30;

  var leadMs = Math.max(20000, warnSec * 1000);
  var limitMs = Math.max(minutes * 60 * 1000, leadMs + 60000);

  var warnTimer;
  var expireTimer;
  var tickTimer;
  var overlay;
  var dialogEl;
  var titleEl;
  var descEl;
  var extendBtn;
  var activeBefore;

  function injectStyles() {
    if (document.getElementById('hb-session-timeout-styles')) return;
    var s = document.createElement('style');
    s.id = 'hb-session-timeout-styles';
    s.textContent =
      '.hb-session-timeout-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.55);display:none;align-items:center;justify-content:center;padding:1rem}' +
      '.hb-session-timeout-overlay[aria-hidden="false"]{display:flex}' +
      '.hb-session-timeout-dialog{max-width:28rem;width:100%;background:var(--colorBody,#fff);color:var(--colorText,#1c1d1d);padding:1.5rem;border-radius:4px;box-shadow:0 8px 32px rgba(0,0,0,.2)}' +
      '.hb-session-timeout-dialog h2{margin:0 0 .75rem;font-size:1.25rem;line-height:1.3}' +
      '.hb-session-timeout-dialog p{margin:0 0 1rem;line-height:1.5}' +
      '.hb-session-timeout-actions{display:flex;flex-wrap:wrap;gap:.5rem;justify-content:flex-end}' +
      '.hb-session-timeout-actions .btn{min-height:44px;min-width:44px;padding:.65rem 1.25rem;cursor:pointer;border:none;font:inherit}' +
      '.hb-session-timeout-actions .btn--primary{background:var(--colorBtn,#1c1d1d);color:var(--colorBtnText,#fff)}' +
      '.hb-session-timeout-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}';
    document.head.appendChild(s);
  }

  function clearTimers() {
    if (warnTimer) clearTimeout(warnTimer);
    if (expireTimer) clearTimeout(expireTimer);
    if (tickTimer) clearInterval(tickTimer);
    warnTimer = expireTimer = tickTimer = null;
  }

  function persistFormDrafts() {
    try {
      var path = location.pathname || '';
      if (path.indexOf('/checkouts') === 0) return;
      var forms = document.querySelectorAll('form');
      var keyBase = 'hb-session-draft:' + path;
      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];
        var fid = form.id || form.getAttribute('name') || 'form-' + i;
        var data = {};
        var inputs = form.querySelectorAll('input, textarea, select');
        for (var j = 0; j < inputs.length; j++) {
          var el = inputs[j];
          var name = el.name;
          var type = (el.type || '').toLowerCase();
          if (!name || type === 'hidden' || type === 'password' || type === 'file' || type === 'button' || type === 'submit') continue;
          if (type === 'checkbox' || type === 'radio') {
            if (el.checked) data[name] = el.value;
          } else {
            data[name] = el.value;
          }
        }
        if (Object.keys(data).length) {
          localStorage.setItem(
            keyBase + ':' + fid,
            JSON.stringify({ savedAt: Date.now(), fields: data })
          );
        }
      }
    } catch (e) {}
  }

  function pingServerSession() {
    if (typeof fetch !== 'function') return;
    var ts = Date.now();
    var cartUrl = routes.cart;
    if (cartUrl) {
      fetch(cartUrl + (cartUrl.indexOf('?') >= 0 ? '&' : '?') + 't=' + ts, {
        credentials: 'same-origin',
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).catch(function () {});
    }
    try {
      fetch(location.pathname + '?t=' + ts, {
        credentials: 'same-origin',
        method: 'HEAD'
      }).catch(function () {});
    } catch (e) {}
  }

  function announce(msg) {
    if (!msg) return;
    var live = document.getElementById('hb-session-timeout-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'hb-session-timeout-live';
      live.className = 'hb-session-timeout-sr';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () {
      live.textContent = msg;
    }, 100);
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !dialogEl) return;
    var focusables = dialogEl.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var list = [];
    for (var i = 0; i < focusables.length; i++) {
      if (!focusables[i].hasAttribute('disabled')) list.push(focusables[i]);
    }
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (!overlay || overlay.getAttribute('aria-hidden') !== 'false') return;
    if (e.key === 'Escape') {
      e.preventDefault();
      extendSession();
      return;
    }
    trapFocus(e);
  }

  function hideDialog() {
    if (!overlay) return;
    if (tickTimer) {
      clearInterval(tickTimer);
      tickTimer = null;
    }
    overlay.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown, true);
    if (activeBefore && typeof activeBefore.focus === 'function') {
      try {
        activeBefore.focus();
      } catch (err) {}
    }
  }

  function extendSession() {
    hideDialog();
    pingServerSession();
    scheduleTimers();
  }

  function onExpire() {
    if (overlay && overlay.getAttribute('aria-hidden') === 'false') {
      hideDialog();
    }
    clearTimers();
    persistFormDrafts();
    var onCheckout = (location.pathname || '').indexOf('/checkouts') === 0;
    announce(
      onCheckout
        ? strings.expiredCheckout || strings.expired || ''
        : strings.expired || ''
    );
    scheduleTimers();
  }

  function showWarning() {
    warnTimer = null;
    if (!overlay || overlay.getAttribute('aria-hidden') === 'false') return;

    activeBefore = document.activeElement;
    var remainingSec = Math.ceil(leadMs / 1000);

    titleEl.textContent = strings.title || 'Session ending soon';
    descEl.textContent = (strings.body || '')
      .replace(/\[seconds\]/g, String(remainingSec))
      .replace(/\[count\]/g, String(remainingSec));
    extendBtn.textContent = strings.extend || 'Extend session';

    overlay.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', onKeydown, true);
    extendBtn.focus();

    var expiresAt = Date.now() + leadMs;
    if (tickTimer) clearInterval(tickTimer);
    tickTimer = setInterval(function () {
      var left = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
      descEl.textContent = (strings.body || '')
        .replace(/\[seconds\]/g, String(left))
        .replace(/\[count\]/g, String(left));
      if (left <= 0) clearInterval(tickTimer);
    }, 1000);
  }

  function scheduleTimers() {
    clearTimers();
    var warnDelay = Math.max(0, limitMs - leadMs);
    warnTimer = setTimeout(showWarning, warnDelay);
    expireTimer = setTimeout(onExpire, limitMs);
  }

  var lastHighFreqActivity = 0;
  function onActivity(e) {
    if (overlay && overlay.getAttribute('aria-hidden') === 'false') return;
    var type = e && e.type;
    if (type === 'mousemove' || type === 'scroll' || type === 'wheel') {
      var now = Date.now();
      if (now - lastHighFreqActivity < 1000) return;
      lastHighFreqActivity = now;
    }
    scheduleTimers();
  }

  var activityBound;
  function bindActivity() {
    if (activityBound) return;
    activityBound = true;
    var ev = ['keydown', 'pointerdown', 'scroll', 'wheel', 'touchstart'];
    var passive = { passive: true };
    for (var i = 0; i < ev.length; i++) {
      document.addEventListener(ev[i], onActivity, passive);
    }
    document.addEventListener('mousemove', onActivity, passive);
  }

  function buildUi() {
    injectStyles();
    overlay = document.createElement('div');
    overlay.id = 'hb-session-timeout-overlay';
    overlay.className = 'hb-session-timeout-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    dialogEl = document.createElement('div');
    dialogEl.className = 'hb-session-timeout-dialog';
    dialogEl.setAttribute('role', 'alertdialog');

    titleEl = document.createElement('h2');
    titleEl.id = 'hb-session-timeout-title';
    dialogEl.setAttribute('aria-labelledby', 'hb-session-timeout-title');

    descEl = document.createElement('p');
    descEl.id = 'hb-session-timeout-desc';
    dialogEl.setAttribute('aria-describedby', 'hb-session-timeout-desc');

    var actions = document.createElement('div');
    actions.className = 'hb-session-timeout-actions';

    extendBtn = document.createElement('button');
    extendBtn.type = 'button';
    extendBtn.className = 'btn btn--primary';
    extendBtn.addEventListener('click', extendSession);

    actions.appendChild(extendBtn);
    dialogEl.appendChild(titleEl);
    dialogEl.appendChild(descEl);
    dialogEl.appendChild(actions);
    overlay.appendChild(dialogEl);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) extendSession();
    });
    document.body.appendChild(overlay);
  }

  function init() {
    if (document.getElementById('hb-session-timeout-overlay')) return;
    buildUi();
    bindActivity();
    scheduleTimers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
